import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ListIcon } from '@phosphor-icons/react';
import { Logo } from '../ui/Logo';

interface MobileTopBarProps {
  onOpenSidebar: () => void;
}

export const MobileTopBar = ({ onOpenSidebar }: MobileTopBarProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-20 flex h-16 items-center gap-3 border-b border-gray-200 bg-[#f4f5f6] px-4 lg:hidden">
      <button
        type="button"
        onClick={onOpenSidebar}
        aria-label={t('sidebar.open_menu')}
        className="flex h-10 w-10 items-center justify-center rounded-lg text-primary transition hover:bg-gray-200"
      >
        <ListIcon size={24} />
      </button>

      <button type="button" onClick={() => navigate('/')} className="flex items-center">
        <Logo className="h-8" />
      </button>
    </header>
  );
};
